import React from 'react';

import { CardProduct } from 'app/model/product/CardProduct';
import { CardOrder } from 'app/model/CardOrder';
import 'app/logic/product/ProductDetails.less';
import { ConvertingMap } from 'app/utils/ConvertingMap';
import { RkkProductDetails } from 'app/logic/product/RkkProductDetails';
import { RkkCardProduct } from 'app/model/product/RkkCardProduct';
import { KkgProductDetails } from 'app/logic/product/KkgProductDetails';
import { KkgCardProduct } from 'app/model/product/KkgCardProduct';
import { DefaultProductDetails } from 'app/logic/product/DefaultProductDetails';

export interface ProductDetailsProps {
    /**
     * Детали выбранного продукта.
     */
    cardProduct: CardProduct;

    /**
     * Текущая заявка.
     */
    order: CardOrder;
}

/**
 * Визуальный блок деталей продукта
 */
export const ProductDetails = ({ cardProduct, order }: ProductDetailsProps) => {
    const CARD_PRODUCT_TYPE_TO_RENDERER: ConvertingMap<
        string,
        React.ReactElement
    > = new ConvertingMap(
        [
            [
                'RKK',
                <RkkProductDetails
                    rkkCardProduct={cardProduct as RkkCardProduct}
                    order={order}
                />,
            ],
            [
                'KKG',
                <KkgProductDetails
                    kkgCardProduct={cardProduct as KkgCardProduct}
                    order={order}
                />,
            ],
        ],
        <DefaultProductDetails cardProduct={cardProduct} order={order} />,
    );

    return CARD_PRODUCT_TYPE_TO_RENDERER.convert(cardProduct.code);
};
